import { Box, LinearProgress, Link, Typography } from "@mui/material"
import React, { useContext } from "react"
import { useParams } from "react-router-dom"
import { customPalette } from "../../theme"
import { pagesUrl } from "../core/appConstants"
import { OrganizationContext } from "../core/context/organization/organization-context"
import { licenseNumberToString } from "../core/services/helper-service"
import { resolveUrl } from "../core/services/http-service"
import { normalizeTo100 } from "../pages/offer/OfferCard"
import { TabEnum } from "./tabs/tabs"

export function BimModelOrganisationImportCounterCard(): React.JSX.Element {
  const { projectId } = useParams()

  const { organization } = useContext(OrganizationContext)

  return (
    <Box display="flex" flexDirection="column" borderRadius={3} p={2} gap={1} sx={{ background: customPalette.lightblue20 }}>
      <Typography fontSize={12} fontWeight={500}>
        Votre équipe a importé dans l’organisation
      </Typography>

      <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
        <Typography fontSize={12} fontWeight={400} sx={{ color: customPalette.darkBlue3 }}>
          Maquettes Beem
        </Typography>
        <Typography fontSize={12} fontWeight={400} sx={{ color: customPalette.darkBlue3 }}>
          {`${organization?.bsBimModelCounter}/${licenseNumberToString(organization?.bsMaxBimModelCount ?? 0)}`}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={normalizeTo100(organization?.bsBimModelCounter ?? 0, organization?.bsMaxBimModelCount ?? 4)}
        sx={{
          height: 10,
          flexGrow: 1,
          borderRadius: 5,
          backgroundColor: (theme) => (theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[200]),
          "& .MuiLinearProgress-bar": {
            borderRadius: 5,
            backgroundColor: customPalette.darkBlue3,
          },
        }}
      />

      <Link
        variant="body2"
        color={customPalette.black}
        textAlign="left"
        href={resolveUrl(pagesUrl.MY_OFFER_PAGE, [], { projectId, tab: TabEnum.PROJECT_BIM_MODEL })}>
        <Typography fontSize={12} fontWeight={400}>
          Mettre à niveau
        </Typography>
      </Link>
    </Box>
  )
}
